<div class="app flex items-center">
  <div class="container mx-auto px-4">
    <div class="flex flex-wrap -mx-3 justify-center">
      <div class="w-full md:w-1/2">
        <div class="clearfix">
          <h1 class="float-left text-6xl mr-4">404</h1>
          <h4 class="pt-3">Oops! You're lost.</h4>
          <p class="text-fq-text-muted">The page you are looking for was not found.</p>
        </div>
        <p-inputgroup class="w-full"><p-inputgroup-addon><fa-icon [icon]="['fas', 'search']"></fa-icon></p-inputgroup-addon><input id="prependedInput" class="fq-form-control" size="16" type="text" placeholder="What are you looking for?">
          <span class="flex items-stretch -ml-px">
            <button class="fq-btn fq-btn-info" type="button">Search</button>
          </span></p-inputgroup>
      </div>
    </div>
  </div>
</div>
